import { useLocalSearchParams } from 'expo-router'

import { INTENTION_TYPE } from '@/src/features/intention/models/Intention.enums'
import { IntentionRewardScreen } from '@/src/features/intention/ui/screens/IntentionRewardScreen'
import type { TSourceParam } from '@/src/general/constants/routes'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'

const IntentionRewardRouterPage = () => {
  const { routes } = useRoutes()

  const { idSharetoken, source, redirect, prayerId, theme } = useLocalSearchParams<
    { idSharetoken: TIdDashSlug; redirect?: string; prayerId: `${number}`; theme?: string } & TSourceParam
  >()

  if (!idSharetoken) return null

  return (
    <IntentionRewardScreen
      prayerId={Number(prayerId)}
      redirect={redirect ?? routes.intentions()}
      source={source ?? TRACKING_SOURCE.UNDEFINED}
      idSharetoken={idSharetoken}
      type={INTENTION_TYPE.INTENTION}
      theme={theme}
    />
  )
}

export default IntentionRewardRouterPage
